import React from 'react';
import urlConfig from './urls';
import { getLabel } from '../utils/i18n';

const {
  site: { resetGoogleAuth: RESET_GOOGLE_AUTH_URL, resetMobile: RESET_MOBILE_URL },
} = urlConfig;

const twoFALocale = (i18n, locale = 'en') => ({
  google: {
    title: getLabel('exchange-2fa-googleAuth', i18n),
    icon: 'computer',
    desc: getLabel('exchange-2fa-googleAuthDesc', i18n),
    label: getLabel('exchange-2fa-googleAuthLabel', i18n),
    error: '',
    footer: <a href={RESET_GOOGLE_AUTH_URL.replace('%locale', locale)}>{getLabel('exchange-2fa-lostGoogleAuthTip', i18n)}</a>,
  },
  mobile: {
    title: getLabel('exchange-2fa-SMSAuth', i18n),
    icon: 'security',
    desc: getLabel('exchange-2fa-SMSAuthDesc', i18n),
    label: getLabel('exchange-2fa-SMSAuthLabel', i18n),
    error: '',
    send: getLabel('exchange-2fa-send', i18n),
    resend: getLabel('exchange-2fa-reSend', i18n),
    resendSms: getLabel('exchange-2fa-reSend', i18n),
    sendSuccessMsg: getLabel('exchange-2fa-sendSMSSuccess', i18n),
    footer: <a href={RESET_MOBILE_URL.replace('%locale', locale)}>{getLabel('exchange-2fa-phoneUnavailable', i18n)}</a>,
  },
  enable: {
    title: getLabel('exchange-2fa-enable2faTip', i18n),
    google: getLabel('exchange-2fa-googleAuth', i18n),
    auth: '',
    sms: getLabel('exchange-2fa-SMSAuth', i18n),
    risk: getLabel('exchange-2fa-notEnablingRisks', i18n),
    youWantToContinue: getLabel('exchange-2fa-continueWithout2FA', i18n),
    improveAccountSecurity: getLabel('exchange-2fa-improveYourSecurity', i18n),
    skip: getLabel('exchange-2fa-skipForNow', i18n),
    goBack: getLabel('exchange-2fa-goBack', i18n),
    enableSmsPath: '/usercenter/security/enable-sms-authenticator',
    enableGooglePath: '/usercenter/security/enable-google-authenticator',
  },
});

export default twoFALocale;
